<template>
<div
  class="card-item"
  :class="{
    pointer: isSelectMode == true
  }"
  @click.stop="selectHandle"
>
<!--  <el-image
    v-if="fileType == 'image'"
    class="img-el"
    :src="itemData.url"
    fit="cover"
    lazy
    referrerPolicy="no-referrer"
  ></el-image>-->
  <div
    v-if="fileType == 'image'"
    class="img-outer">
    <img
      v-if="fileType == 'image'"
      class="img-el"
      :src="itemData.url"
      alt=""
      referrerPolicy="no-referrer"
    >
  </div>


  <div v-else class="card-preview">
    <icon-svg
      icon-class="yuyin"
      v-if="fileType=='voice'"
      class="icon-inner"
    ></icon-svg>
    <icon-svg
      icon-class="shipin"
      v-if="fileType=='video'"
      class="icon-inner"
    ></icon-svg>
    <p class="card-preview-text">管理后台不支持预览<br/>微信中可正常播放</p>
  </div>
  <h3 class="title line-text-flow">{{itemData.name}}</h3>
  <div class="date">{{parseTime(itemData.updateTime)}}</div>
  <div class="flex justify-between align-center btn-modules" v-show="!isSelectMode">
<!--
icon="el-icon-copy-document"
-->
    <el-button
      type="text"

      @click="onCopySuccess"
    >复制media_id</el-button>
<!--
icon="el-icon-delete"
-->
    <el-button
      type="text"
      v-if="isAuth('wx:wxassets:delete')"
      class="delete-btn"
      @click="deleteHandle(itemData.mediaId)"
    >删除</el-button>
  </div>
</div>
</template>

<script>
import copy from 'copy-to-clipboard';
import { parseTime } from "@/utils";

export default {
  name: "cardItem",
  props: {
    fileType: {
      type: String,
      default: 'image',
    },
    itemData: {
      type: Object,
      default(){
        return {}
      }
    },
    isSelectMode:{
      type: Boolean,
      default: false
    }
  },
  created(){
    console.log(this.itemData);
  },
  methods: {
    parseTime,
    selectHandle(){
      this.$emit('selected', this.itemData);
    },
    onCopySuccess(){
      copy(this.itemData.mediaId);
      this.$message.success('已复制')
    },
    onCopyError(err){
      this.$message.error('复制失败,可能是此浏览器不支持复制')
    },
    //删除
    deleteHandle(id) {
      this.$confirm(`确定对[mediaId=${id}]进行删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: 'wx/manage/wxAssets/materialDelete',
          method: 'post',
          data: { mediaId: id,type: 1, }
        }).then((data) => {
          if (data && data.code === 200) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () =>  {
                this.$emit('delete-success');
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-item {
  width: 100%;
  border: 1px solid #E0E4F2;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
  .img-outer {
    height: 170px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%; /* 或者指定具体的宽度 */
    overflow: hidden; /* 确保图片不会超出容器 */
    img{
      min-width: 100%;
    min-height: 100%;
    object-fit: cover; /* 保持图片比例并覆盖整个容器 */
    }
  }
  .img-el {
    line-height: 170px;
    //height: 170px;
    width: 100%;
    /*max-height: 170px;
    width: 100%;*/
  }
  .title,
  .date,
  .btn-modules {
    padding: 0 10px;
  }
  .btn-modules {
    flex-wrap: wrap;
    font-size: 12px;
    //padding: 0 5px;
  }
  .title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    margin-top: 10px;
    word-break: break-word;
    white-space:nowrap;
  }
  .date {
    color: #B7B8C9;
    font-size: 12px;
  }
  .card-preview{
    padding: 20px 10px;
    background-color: #EFF3FF;
    color: #B7B8C9;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    .icon-inner {
      font-size: 30px;
    }
    .card-preview-text {

      margin-left: 10px;
    }
  }
}
</style>
